import { makeStyles } from "@material-ui/core";

export const useStyleDisplay = makeStyles(theme => ({
    [theme?.breakpoints.up("1923")]: {
        shadow:{
            boxShadow: '1px 2px 5px #0005 !important',
        },
        bgBlue: {
            background: "#4da7da",
        },
        textBlue: {
            color: "#4da7da",
        },
        bgGray: {
            background: "#ebedf3"
        },
        bgGray2: {
            background: "#d9d9d9"
        },
        textGray: {
            color: "#ebedf3"
        },
        borderL: {
            borderLeft: '5px solid #ee7800',
        },
        borderR:{
            borderRight: '5px solid #ee7800',
        },
        headTextTime: {
            fontSize: "calc(100% + 54px)",
        },
        footerTextMarquee: {
            fontSize: "calc(100% + 42px)",
        },
        inputDropdownText: {
            backgroundColor: 'rgb(77,167,218)',
            "& [textplaceholder]:before": {
                lineHeight: 1.4,
            },
            "& .MuiSelect-root.MuiSelect-select": {
                fontSize: "calc(100% + 22px)",
            },
            "& .MuiSelect-selectMenu": {
                lineHeight: 1.4,
            },
        },
        dropdownMenuText: {
            backgroundColor: 'rgb(77,167,218)',
            "& .MuiMenuItem-root": {
                fontSize: "calc(100% + 18px)",
            },
        },
        classPaperListMenuRoom: {
            "& .MuiListItemText-root > span": {
                fontSize: "calc(100% + 16px)",
            },
            "& .MuiListItemIcon-root > svg": {
                fontSize: "calc(100% + 32px)",
            },
        },
        btnUpsizeFont: {
            "& .MuiButtonGroup-groupedOutlinedHorizontal": {
                border: "none",
            },
            "& .MuiButtonBase-root.MuiButton-root": {
                backgroundColor: "rgb(77,167,218)",
                color: "#ffffff",
                paddingTop: 14,
                paddingBottom: 14,
                lineHeight: 1.4,
            },
            "& .MuiButton-label svg": {
                width: 52,
                height: 52,
            },
            "& .text-show-value":{
                fontSize: "calc(100% + 18px)",
                lineHeight: 1.4,
            }
        },
    },
    [theme?.breakpoints.down("1922")]: {
        shadow:{
            boxShadow: '1px 2px 5px #0005 !important',
        },
        bgBlue: {
            background: "#4da7da",
        },
        textBlue: {
            color: "#4da7da",
        },
        bgGray: {
            background: "#ebedf3"
        },
        bgGray2: {
            background: "#d9d9d9"
        },
        textGray: {
            color: "#ebedf3"
        },
        borderL: {
            borderLeft: '3px solid #ee7800',
        },
        borderR:{
            borderRight: '3px solid #ee7800',
        },
        headTextTime: {
            fontSize: 34,
        },
        footerTextMarquee: {
            fontSize: 22,
        },
        inputDropdownText: {
            "& [textplaceholder]:before": {
                lineHeight: 1.4,
            },
            "& .MuiSelect-root.MuiSelect-select": {
                fontSize: 16,
            },
            "& .MuiSelect-selectMenu": {
                lineHeight: 1.4,
            },
            backgroundColor: 'rgb(77,167,218)',
        },
        dropdownMenuText: {
            backgroundColor: 'rgb(77,167,218)',
            "& .MuiMenuItem-root": {
                fontSize: 14,
            },
        },
        classPaperListMenuRoom: {
            "& .MuiListItemText-root > span": {
                fontSize: 12,
            },
            "& .MuiListItemIcon-root > svg": {
                fontSize: 22,
            },
        },
        btnUpsizeFont: {
            "& .MuiButtonGroup-groupedOutlinedHorizontal": {
                border: "none",
            },
            "& .MuiButtonBase-root.MuiButton-root": {
                backgroundColor: "rgb(77,167,218)",
                color: "#ffffff",
                paddingTop: 14,
                paddingBottom: 14,
                lineHeight: 1.4,
            },
            "& .MuiButton-label svg": {
                width: 25,
                height: 25,
            },
            "& .text-show-value":{
                fontSize: 16,
                lineHeight: 1.4,
            }
        },
    },
}));
